import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React, { useState, useEffect, lazy } from 'react';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { getSession } from '@jbrowse/core/util';
import { Button, CircularProgress, FormControl, Container, Grid } from '@mui/material';
import { ErrorMessage, AssemblySelector } from '@jbrowse/core/ui';
// icons
import CloseIcon from '@mui/icons-material/Close';
// locals
import RefNameAutocomplete from './RefNameAutocomplete';
import { fetchResults as _fetchResults, splitLast } from './util';
var SearchResultsDialog = lazy(function () {
  return import('./SearchResultsDialog');
});
var useStyles = makeStyles()(function (theme) {
  return {
    importFormContainer: {
      padding: theme.spacing(2)
    },
    button: {
      margin: theme.spacing(2)
    },
    container: {
      padding: theme.spacing(4)
    }
  };
});
var ImportForm = observer(function (_ref) {
  var model = _ref.model;
  var _a;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var session = getSession(model);
  var assemblyNames = session.assemblyNames,
    assemblyManager = session.assemblyManager,
    textSearchManager = session.textSearchManager;
  var rankSearchResults = model.rankSearchResults,
    isSearchDialogDisplayed = model.isSearchDialogDisplayed,
    error = model.error;
  var _useState = useState(assemblyNames[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAsm = _useState2[0],
    setSelectedAsm = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    option = _useState4[0],
    setOption = _useState4[1];
  var searchScope = model.searchScope(selectedAsm);
  var assembly = assemblyManager.get(selectedAsm);
  var assemblyError = assemblyNames.length ? assembly === null || assembly === void 0 ? void 0 : assembly.error : 'No configured assemblies';
  var regions = (assembly === null || assembly === void 0 ? void 0 : assembly.regions) || [];
  var displayError = assemblyError || error;
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    value = _useState6[0],
    setValue = _useState6[1];
  var r0 = (_a = regions[0]) === null || _a === void 0 ? void 0 : _a.refName;
  // useEffect resets to an "initial state" of displaying first region from assembly
  // after assembly change. needs to react to selectedAsm as well as r0 because changing
  // assembly will run setValue('') and then r0 may not change if assembly names are the
  // same across assemblies, but it still needs to be reset
  useEffect(function () {
    setValue(r0);
  }, [r0, selectedAsm]);
  function navToOption(_x) {
    return _navToOption.apply(this, arguments);
  } // gets a string as input, or use stored option results from previous query,
  // then re-query and
  // 1) if it has multiple results: pop a dialog
  // 2) if it's a single result navigate to it
  // 3) else assume it's a locstring and navigate to it
  function _navToOption() {
    _navToOption = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(option) {
      var location, trackId;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            location = option.getLocation();
            trackId = option.getTrackId();
            if (!location) {
              _context2.next = 6;
              break;
            }
            _context2.next = 5;
            return model.navToLocString(location, selectedAsm);
          case 5:
            if (trackId) {
              model.showTrack(trackId);
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _navToOption.apply(this, arguments);
  }
  function handleSelectedRegion(_x2) {
    return _handleSelectedRegion.apply(this, arguments);
  } // implementation notes:
  // having this wrapped in a form allows intuitive use of enter key to submit
  function _handleSelectedRegion() {
    _handleSelectedRegion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(input) {
      var _a, _splitLast, _splitLast2, ref, rest, allRefs, results;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            if (!((option === null || option === void 0 ? void 0 : option.getDisplayString()) === input && option.hasLocation())) {
              _context3.next = 6;
              break;
            }
            _context3.next = 4;
            return navToOption(option);
          case 4:
            _context3.next = 31;
            break;
          case 6:
            if (!((_a = option === null || option === void 0 ? void 0 : option.results) === null || _a === void 0 ? void 0 : _a.length)) {
              _context3.next = 10;
              break;
            }
            model.setSearchResults(option.results, option.getLabel());
            _context3.next = 31;
            break;
          case 10:
            _splitLast = splitLast(input, ':'), _splitLast2 = _slicedToArray(_splitLast, 2), ref = _splitLast2[0], rest = _splitLast2[1];
            allRefs = (assembly === null || assembly === void 0 ? void 0 : assembly.allRefNamesWithLowerCase) || [];
            if (!(allRefs.includes(input) || allRefs.includes(ref) && !Number.isNaN(parseInt(rest, 10)))) {
              _context3.next = 17;
              break;
            }
            _context3.next = 15;
            return model.navToLocString(input, selectedAsm);
          case 15:
            _context3.next = 31;
            break;
          case 17:
            _context3.next = 19;
            return _fetchResults({
              queryString: input,
              searchType: 'exact',
              searchScope: searchScope,
              rankSearchResults: rankSearchResults,
              textSearchManager: textSearchManager,
              assembly: assembly
            });
          case 19:
            results = _context3.sent;
            if (!(results.length > 1)) {
              _context3.next = 24;
              break;
            }
            model.setSearchResults(results, input.toLowerCase());
            _context3.next = 31;
            break;
          case 24:
            if (!(results.length === 1)) {
              _context3.next = 29;
              break;
            }
            _context3.next = 27;
            return navToOption(results[0]);
          case 27:
            _context3.next = 31;
            break;
          case 29:
            _context3.next = 31;
            return model.navToLocString(input, selectedAsm);
          case 31:
            _context3.next = 37;
            break;
          case 33:
            _context3.prev = 33;
            _context3.t0 = _context3["catch"](0);
            console.error(_context3.t0);
            session.notify("".concat(_context3.t0), 'warning');
          case 37:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 33]]);
    }));
    return _handleSelectedRegion.apply(this, arguments);
  }
  return React.createElement("div", {
    className: classes.container
  }, displayError ? React.createElement(ErrorMessage, {
    error: displayError
  }) : null, React.createElement(Container, {
    className: classes.importFormContainer
  }, React.createElement("form", {
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();
              model.setError(undefined);
              if (!value) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return handleSelectedRegion(value);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onSubmit(_x3) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, React.createElement(Grid, {
    container: true,
    spacing: 1,
    justifyContent: "center",
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(FormControl, null, React.createElement(AssemblySelector, {
    onChange: function onChange(val) {
      setSelectedAsm(val);
      setValue('');
    },
    localStorageKey: "lgv",
    session: session,
    selected: selectedAsm
  }))), React.createElement(Grid, {
    item: true
  }, selectedAsm ? assemblyError ? React.createElement(CloseIcon, {
    style: {
      color: 'red'
    }
  }) : value ? React.createElement(FormControl, null, React.createElement(RefNameAutocomplete, {
    fetchResults: function fetchResults(queryString) {
      return _fetchResults({
        queryString: queryString,
        assembly: assembly,
        textSearchManager: textSearchManager,
        rankSearchResults: rankSearchResults,
        searchScope: searchScope
      });
    },
    model: model,
    assemblyName: assemblyError ? undefined : selectedAsm,
    value: value,
    // note: minWidth 270 accommodates full width of helperText
    minWidth: 270,
    onChange: function onChange(str) {
      return setValue(str);
    },
    onSelect: function onSelect(val) {
      return setOption(val);
    },
    TextFieldProps: {
      variant: 'outlined',
      helperText: 'Enter sequence name, feature name, or location',
      style: {
        minWidth: '175px'
      }
    }
  })) : React.createElement(CircularProgress, {
    role: "progressbar",
    size: 20,
    disableShrink: true
  }) : null), React.createElement(Grid, {
    item: true
  }, React.createElement(FormControl, null, React.createElement(Button, {
    type: "submit",
    disabled: !value,
    className: classes.button,
    variant: "contained",
    color: "primary"
  }, "Open")), React.createElement(FormControl, null, React.createElement(Button, {
    disabled: !value,
    className: classes.button,
    onClick: function onClick() {
      model.setError(undefined);
      model.showAllRegionsInAssembly(selectedAsm);
    },
    variant: "contained",
    color: "secondary"
  }, "Show all regions in assembly")))))), isSearchDialogDisplayed ? React.createElement(SearchResultsDialog, {
    model: model,
    optAssemblyName: selectedAsm,
    handleClose: function handleClose() {
      return model.setSearchResults(undefined, undefined);
    }
  }) : null);
});
export default ImportForm;